<!-- <section class="gst-invoice-maker">
  <div class="content-wrapper">
    <h2>AI Powered GST Invoice Generator</h2>
    <p class="description">
      Streamline your invoicing process with <b>automated HSN categorization</b> and <b>GST rate calculation</b>. <br>
      Simple, secure, and ready to use instantly!
    </p>
    <a href="/tools/gst-invoice" class="cta-button">
      Start Generating Invoice &nbsp;&nbsp;
      <mat-icon style="vertical-align: middle;">arrow_right_alt</mat-icon>
    </a>
  </div>
</section> -->

<!-- <app-job-blogs></app-job-blogs> -->
<div class="blogs-insights-container">
  <div class="header">
    <h2>
      Inforida<span> blogs,</span> <br />
      insights & more<span>.</span>
    </h2>
    <!-- <a href="https://blog.inforida.com/" target="_blank" mat-button color="primary">See all</a> -->
  </div>

  <div class="blogs-grid">
    <!-- Blog 1 -->
    <div class="blog-card" (click)="openBlogLink(1)">
      <!-- <img
        src="../../../assets/images/pexels-emily-ranquist-493228-1205651.jpg"
        alt="Blog Image 1"
      /> -->
      <div class="background-image one"></div>
      <div class="blog-content">
        <h3 class="blog-title">A Decade in Review</h3>
        <p class="blog-date">May 13, 2024</p>
        <p class="blog-description">
          Analysing CBSE Class 10th and 12th Results with Data Visualisation...
        </p>
        <a>Read More →</a>
      </div>
    </div>

    <!-- Blog 3 -->
    <div class="blog-card" (click)="openBlogLink(2)">
      <!-- <img
        src="../../../assets/images/pexels-tima-miroshnichenko-5428148.jpg"
        alt="Blog Image 3"
      /> -->
      <div class="background-image two"></div>
      <div class="blog-content">
        <h3 class="blog-title">The Secret to School Success</h3>
        <p class="blog-date">Feb 18, 2023</p>
        <p class="blog-description">
          As schools continue to adapt to the ever-evolving world of education,
          the role of technology has become more important than ever before...
        </p>
        <a>Read More →</a>
      </div>
    </div>

    <!-- Blog 2 -->
    <div class="blog-card" (click)="openBlogLink(3)">
      <!-- <img src="../../../assets/images/ved-blog-1.png" alt="Blog Image 2" />
        -->
      <div class="background-image three"></div>
      <div class="blog-content">
        <h3 class="blog-title">
          5 Ways Inforida Can Make Teacher's Lives Easier
        </h3>
        <p class="blog-date">September 28, 2014</p>
        <p class="blog-description">
          Teachers, you're the heart and soul of education. You inspire young
          minds, nurture curiosity, and help students blossom into their full
          potential...
        </p>
        <a>Read More →</a>
      </div>
    </div>
    <!-- Blog 4 -->
    <div class="blog-card" (click)="openBlogLink(4)">
      <!-- <img
        src="https://blog.inforida.com/content/images/size/w750/2024/04/pexels-rdne-stock-project-5922675.jpg"
        alt="Blog Image 4"
      /> -->
      <div class="background-image four"></div>
      <div class="blog-content">
        <h3 class="blog-title">Mastering School Finances with Inforida</h3>
        <p class="blog-date">May 10, 2024</p>
        <p class="blog-description">
          Managing finances effectively is a critical aspect of running a school
          smoothly...
        </p>
        <a>Read More →</a>
      </div>
    </div>
  </div>

  <div class="more-blogs" (click)="openBlogLink(5)">See more blogs →</div>
</div>

<div class="foot-container">
  <div class="faq-conatiner">
    <div class="measure-div-title">
      Frequently <span>Asked</span> <br />
      Questions<span>.</span>
    </div>
    <div
      class="ques-Ans"
      *ngFor="let qnA of questionAnswer; let i = index"
      [ngClass]="{ active: isViewMore[i] }"
    >
      <div (click)="viewMore(i)" class="question">
        <span class="measure-div-subtitle">
          <b>{{ qnA.question }}</b>
        </span>
        <span [ngClass]="!isViewMore[i] ? 'fa fa-plus' : 'fa fa-minus'"></span>
      </div>
      <div
        *ngIf="isViewMore[i]"
        class="measure-div-subtitle answer"
        style="padding: 8px 24px; font-style: italic"
        [ngClass]="{ visible: isViewMore[i] }"
      >
        <p>{{ qnA.answer }}</p>
      </div>
    </div>
  </div>

  <div class="app-footer-1">
    <div class="foot-right">
      <h1 class="foot-title-1">
        Manage Your school <br />
        Anytime, Anywhere
      </h1>
      <p class="foot-sub-title">
        Download the Inforida mobile app to stay connected, streamline
        operations, and manage tasks effortlessly—no matter where you are
      </p>
      <div class="foot-store-wrap">
        <a
          href="https://play.google.com/store/apps/details?id=inforida.in.inforidaapp"
          target="_blank"
        >
          <img src="../../../assets/images/playstore.png" />
        </a>
        <!-- <a
          href="https://play.google.com/store/apps/details?id=inforida.in.inforidaapp"
          target="_blank"
        >
          <img src="../../../assets/images/appstore.png" />
        </a> -->
      </div>
    </div>
    <div class="col-4">
      <img src="../../../assets/images/mobile.png" class="mobile-img" />
      <img src="../../../assets/images/Star.png" class="foot-star" />
    </div>
  </div>
  <!-- <div class="app-footer-2 rect-view" style="display: flex">
    <div style="width: 50%">
      <img src="../../assets/images/Group 7709.svg" class="image-cls1" />
      <img src="../../assets/images/Group 164.svg" class="img-cls2" />
      <h1 class="foot-title-2">
        Move to a
        <br />
        Simple, Smarter & Scalable <br />
        Performance Platform
      </h1>
      <img src="../../assets/images/Group 175.png" class="img-cls3" />
      <img
        src="../../assets/images/Ellipse 33.png"
        style="margin: -10px 10px"
      />
    </div>

    <div style="width: 50%">
      <div style="margin: 10px 20px 20px 55px">
        <div mat-dialog-content class="form">
          <form class="example-form">
            <table class="example-full-width" cellspacing="0">
              <tr>
                <td style="width: 50%">
                  <mat-form-field
                    class="footer example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Enter your name</mat-label>
                    <input
                      matInput
                      [(ngModel)]="formData.name"
                      #nameWeb="ngModel"
                      minlength="5"
                      maxlength="30"
                      type="text"
                      required
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-error *ngIf="formData.name.length < 1"
                      >Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="nameWeb.invalid && formData.name.length > 0"
                    >
                      Name is not valid
                    </mat-error>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field
                    class="footer example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Enter your mobile no</mat-label>
                    <input
                      matInput
                      [(ngModel)]="formData.mobile"
                      #mobileWeb="ngModel"
                      type="text"
                      maxlength="10"
                      minlength="10"
                      required
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-hint align="end"
                      >{{ formData.mobile.length }}/10</mat-hint
                    >
                    <mat-error *ngIf="formData.mobile.length < 1"
                      >Mobile no is required</mat-error
                    >
                    <mat-error
                      *ngIf="mobileWeb.invalid && formData.mobile.length > 0"
                    >
                      Mobile number is not valid
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
            </table>
            <table class="example-full-width" cellspacing="0">
              <tr>
                <td>
                  <mat-form-field
                    class="footer example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Enter Institute Name</mat-label>
                    <input
                      matInput
                      value=""
                      [(ngModel)]="formData.organizationName"
                      [ngModelOptions]="{ standalone: true }"
                      maxlength="100"
                      minlength="10"
                      #organizationNameWeb="ngModel"
                      required
                    />
                    <mat-error *ngIf="formData.organizationName.length < 1"
                      >Institute Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        organizationNameWeb.invalid &&
                        formData.organizationName.length > 0
                      "
                    >
                      Institute name is not valid.
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
            </table>
            <table class="example-full-width" cellspacing="0">
              <tr>
                <td>
                  <mat-form-field
                    class="footer example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Enter number of students</mat-label>
                    <input
                      matInput
                      [(ngModel)]="formData.totalStudents"
                      [ngModelOptions]="{ standalone: true }"
                      type="number"
                      max="50000"
                      #totalStudentsWeb="ngModel"
                      required
                    />
                    <mat-error *ngIf="totalStudentsWeb.invalid">
                      Total students is not valid.
                    </mat-error>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field
                    class="footer example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Enter city name</mat-label>
                    <input
                      matInput
                      [(ngModel)]="formData.city"
                      #cityWeb="ngModel"
                      minlength="2"
                      maxlength="100"
                      [ngModelOptions]="{ standalone: true }"
                      required
                    />
                    <mat-error *ngIf="formData.city.length < 1"
                      >City name is required</mat-error
                    >
                    <mat-error
                      *ngIf="cityWeb.invalid && formData.city.length > 0"
                    >
                      City name is not valid.
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="subtitle">
                  How soon you want to integrate Inforida to your ecosystem?
                </td>
              </tr>
              <tr>
                <td>
                  <mat-radio-group
                    [(ngModel)]="formData.days"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <mat-radio-button
                      class="radio"
                      value="7"
                      style="margin-right: 30px"
                      >In 7 days</mat-radio-button
                    >
                    <mat-radio-button
                      value="30"
                      class="radio"
                      style="margin-right: 30px"
                      >In 30 days</mat-radio-button
                    >
                  </mat-radio-group>
                </td>
              </tr>
            </table>
            <div>
              <button
                (click)="submitDetails()"
                mat-raised-button
                class="btn-get"
                color="primary"
                mat-dialog-close
              >
                Book a demo &nbsp;&nbsp;
                <mat-icon>arrow_right_alt</mat-icon>
              </button>
              <span
                ><img
                  src="../../assets/images/Group 170.svg"
                  style="margin: -25px 10px 0px 0px; float: right"
              /></span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div> -->
  <div class="container">
    <div class="app-footer-3">
      <div class="footer-heading">
        <div class="inforida-logo" routerLink="/home">
          <img
            src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/new-black-inforida-logo.png"
            alt="Inforida"
          />
        </div>
        <button (click)="goToPage()">Book Free demo →</button>
      </div>
      <div class="wrapper">
        <div class="footer-text">
          <h2>Empowering Education</h2>
          <div class="socialmedia-wrap">
            <a
              class="media-wrap"
              href="https://www.linkedin.com/company/inforidatech"
              target="_blank"
            >
              <img src="../../../assets/images/foot_linkdin.png" />
            </a>
            <a
              class="media-wrap"
              href="https://wa.me/7459895863"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="../../../assets/images/foot_wa.png" />
            </a>
            <a
              class="media-wrap"
              href="https://www.facebook.com/InforidaTech"
              target="_blank"
            >
              <img src="../../../assets/images/foot_fb.png" />
            </a>
            <a
              class="media-wrap"
              href="https://www.instagram.com/InforidaTech"
              target="_blank"
            >
              <img src="../../../assets/images/foot_insta.png" />
            </a>
            <a
              class="media-wrap"
              href="https://www.youtube.com/@Inforida"
              target="_blank"
            >
              <img src="../../../assets/images/youtube.png" />
            </a>
          </div>
          <div>
            <div class="contact-card">
              <div class="contact-image">
                <img src="../../../assets//images/phones.png" />
              </div>
              <a [href]="'tel:+91' + '7459895863'" class="links">
                <p>+91-7459895863</p>
              </a>
            </div>
            <div class="contact-card">
              <div class="contact-image">
                <img src="../../../assets/images/email.png" />
              </div>
              <a [href]="'mailto:' + 'teaminforida.in'" class="links">
                <p>teaminforida.in</p>
              </a>
            </div>
            <div class="contact-card new-conatact" style="max-width: 290px">
              <div class="contact-image" style="margin-left: 10px">
                <img src="../../../assets/images/map-pin.png" />
              </div>
              <p style="text-align: left; padding-left: 6px">
                Inforida Technologies Private Limited 1153, HSR Layout, Banglore
                - 560102
              </p>
            </div>
            <button (click)="goToPage()" class="demo-mobile">
              Book Free demo →
            </button>
          </div>
        </div>
        <div class="footer-container">
          <div class="footer-menu menu">
            <h2>Menu</h2>
            <button routerLink="/about-us">About us</button>
            <button routerLink="/contact-us">Contact us</button>
            <button routerLink="/why-inforida">Why Inforida</button>
            <button routerLink="/" (click)="goToCareers()">Careers</button>
            <button routerLink="/blogs">
              <a class="links" target="_blank">Blogs </a>
            </button>
          </div>
          <div class="footer-menu ecosystem">
            <h2>Ecosystem</h2>
            <button routerLink="/admin-staff">For admin staff</button>
            <button routerLink="/academic-staff">For Academic staff</button>
            <button routerLink="/parents">For parents</button>
          </div>
          <div class="footer-menu products">
            <h2>Products</h2>
            <button routerLink="/products/goood-morning">
              Goood Morning app
            </button>
            <button routerLink="/products/QuickEnroll-AI">
              QuickEnroll AI
            </button>
            <button routerLink="/products/inforida-orbit">
              Inforida Orbit App
            </button>
            <!-- <button>Job board</button> -->
            <button>AI GST Invoice</button>
          </div>
          <div class="footer-menu others">
            <h2>Others</h2>
            <button routerLink="/privacy">Privacy policy</button>
            <button routerLink="/terms">Terms of use</button>
            <button routerLink="/sales">Sales and refund</button>
          </div>
          <!-- <div class="footer-contactus footer-menu">
            <h2>Contact us</h2>
            <div class="contact-card">
              <div class="contact-image">
                <img src="../../../assets//images/phones.png" />
              </div>
              <a [href]="'tel:+91' + '9491587279'" class="links">
                <p>+91-9491587279</p>
              </a>
            </div>
            <div class="contact-card">
              <div class="contact-image">
                <img src="../../../assets/images/email.png" />
              </div>
              <a [href]="'mailto:' + 'teaminforida.in'" class="links">
                <p>teaminforida.in</p>
              </a>
            </div>
            <div class="contact-card new-conatact">
              <div class="contact-image">
                <img src="../../../assets/images/map-pin.png" />
              </div>
              <p>Inforida Technologies 1153, HSR Layout, Banglore - 560102</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="footer-location">
        <div class="location-wrapper">
          <div class="loc-image">
            <img src="../../../assets/images/map-pin.png" />
          </div>
          <div class="footer-location-text">
            <h2>Head Office</h2>
            <p>
              Inforida Technologies Private Limited <br />
              1153, HSR Layout, Banglore - 560102
            </p>
          </div>
        </div>
        <div class="location-wrapper">
          <div class="loc-image">
            <img src="../../../assets/images/map-pin.png" />
          </div>
          <div class="footer-location-text">
            <h2>Zonal office</h2>
            <p>
              Inforida Technologies Private Limited <br />
              F45, Skyline Plaza, Sushant Golf City, Shaheed Path, Lucknow -
              226030
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="display" style="margin: 50px 0px 30px 0px">
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/products"
          [ngClass]="{ 'selected-footer': currentUrlState === '/products' }"
        >
          Products
        </button>
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/about-us"
          [ngClass]="{ 'selected-footer': currentUrlState === '/about-us' }"
        >
          about us
        </button>
        <a
          mat-button
          class="mar-50 foot-text"
          href="https://blog.inforida.com/"
          target="_blank"
          >blogs</a
        >
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/contact-us"
          [ngClass]="{ 'selected-footer': currentUrlState === '/contact-us' }"
        >
          contact us
        </button>
      </div>
      <div class="display" style="margin-bottom: 15px">
        <button mat-button routerLink="/privacy" class="sub-nav">
          privacy policy
        </button>
        <button
          mat-button
          style="margin-left: 30px"
          class="sub-nav"
          routerLink="/terms"
        >
          term of use
        </button>
        <button
          mat-button
          style="margin-left: 30px"
          class="sub-nav"
          routerLink="/sales"
        >
          sales and refund
        </button>
        <button
          mat-button
          style="margin-left: 30px"
          class="sub-nav"
          routerLink="/legal"
        >
          legal
        </button>
      </div> -->
      <div class="copy-right">
        © 2025 Inforida Technologies Private Limited | All Rights Reserved
      </div>
      <div class="love">Made with ❤️ in India</div>
    </div>
  </div>
</div>
<!-- <button mat-button style=" margin-left: 30px;" class=" sub-nav" routerLink="/sitemap">sitemap</button> -->

<!-- <div class="foot-container" *ngIf="isMobile()">
  <div style="width: 1200px" class="mb-faq">
    <div class="measure-div-title">FAQs</div>
    <div class="measure-div-subtitle" style="margin-bottom: 35px">
      <small>Answers to some questions you might have.</small>
    </div>
    <div class="ques-Ans" *ngFor="let qnA of questionAnswer; let i = index">
      <div (click)="viewMore(i)" class="question">
        <span class="measure-div-subtitle">
          <b>{{ qnA.question }}</b>
        </span>
        <span [ngClass]="!isViewMore[i] ? 'fa fa-plus' : 'fa fa-minus'"></span>
      </div>
      <div
        *ngIf="isViewMore[i]"
        class="measure-div-subtitle"
        style="padding: 8px 24px; font-style: italic"
      >
        <small>{{ qnA.answer }}</small>
      </div>
    </div>
  </div>
  <mat-grid-list cols="1" rowHeight="30vh" class="app-footer-1">
    <mat-grid-tile colspan="1">
      <div style="margin-top: 20px">
        <h1 class="foot-title-1">
          Get inforida experience <br />
          on the go!
        </h1>
        <p class="foot-sub-title">Download for android</p>
        <a
          href="https://play.google.com/store/apps/details?id=inforida.in.inforidaapp"
          target="_blank"
        >
          <img src="../../../assets/images/playstore.png" height="60px" />
        </a>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
      <img
        src="../../../assets/images/mobile.png"
        height="250px"
        width="200px"
        class="mobile-img"
      />
    </mat-grid-tile>
  </mat-grid-list>
  <div class="app-footer-2" style="display: flex">
    <div>
      <img src="../../assets/images/Group 7709.svg" class="image-cls1" />

      <h1 class="foot-title-2">
        Move to a smarter <br />
        and scalable<br />Platform
      </h1>
    </div>
    <div>
      <div class="form">
        <form class="example-form">
          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field
                  class="footer example-full-width"
                  appearance="outline"
                >
                  <mat-label>Enter your name</mat-label>
                  <input
                    matInput
                    [(ngModel)]="formData.name"
                    #nameMobile="ngModel"
                    minlength="5"
                    maxlength="30"
                    type="text"
                    required
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <mat-error *ngIf="formData.name.length < 1"
                    >Name is required</mat-error
                  >
                  <mat-error
                    *ngIf="nameMobile.invalid && formData.name.length > 0"
                  >
                    Name is not valid
                  </mat-error>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field
                  class="footer example-full-width"
                  appearance="outline"
                >
                  <mat-label>Enter your mobile no</mat-label>
                  <input
                    matInput
                    [(ngModel)]="formData.mobile"
                    #mobileMobile="ngModel"
                    type="text"
                    maxlength="10"
                    minlength="10"
                    required
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <mat-hint align="end"
                    >{{ formData.mobile.length }}/10</mat-hint
                  >
                  <mat-error *ngIf="formData.mobile.length < 1"
                    >Mobile no is required</mat-error
                  >
                  <mat-error
                    *ngIf="mobileMobile.invalid && formData.mobile.length > 0"
                  >
                    Mobile number is not valid
                  </mat-error>
                </mat-form-field>
              </td>
            </tr>
          </table>
          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field
                  class="footer example-full-width"
                  appearance="outline"
                >
                  <mat-label>Enter Institute Name</mat-label>
                  <input
                    matInput
                    value=""
                    [(ngModel)]="formData.organizationName"
                    [ngModelOptions]="{ standalone: true }"
                    maxlength="100"
                    minlength="10"
                    #organizationNameMobile="ngModel"
                    required
                  />
                  <mat-error *ngIf="formData.organizationName.length < 1"
                    >Institute Name is required</mat-error
                  >
                  <mat-error
                    *ngIf="
                      organizationNameMobile.invalid &&
                      formData.organizationName.length > 0
                    "
                  >
                    Institute name is not valid.
                  </mat-error>
                </mat-form-field>
              </td>
            </tr>
          </table>
          <table class="example-full-width" cellspacing="0">
            <tr>
              <td>
                <mat-form-field
                  class="footer example-full-width"
                  appearance="outline"
                >
                  <mat-label>Enter number of students</mat-label>
                  <input
                    matInput
                    [(ngModel)]="formData.totalStudents"
                    [ngModelOptions]="{ standalone: true }"
                    type="number"
                    max="50000"
                    #totalStudentsMobile="ngModel"
                    required
                  />
                  <mat-error *ngIf="totalStudentsMobile.invalid">
                    Total students is not valid.
                  </mat-error>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field
                  class="footer example-full-width"
                  appearance="outline"
                >
                  <mat-label>Enter city name</mat-label>
                  <input
                    matInput
                    [(ngModel)]="formData.city"
                    #cityMobile="ngModel"
                    minlength="2"
                    maxlength="100"
                    [ngModelOptions]="{ standalone: true }"
                    required
                  />
                  <mat-error *ngIf="formData.city.length < 1"
                    >City name is required</mat-error
                  >
                  <mat-error
                    *ngIf="cityMobile.invalid && formData.city.length > 0"
                  >
                    City name is not valid.
                  </mat-error>
                </mat-form-field>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td class="subtitle">
                How soon you want to integrate Inforida to your ecosystem?
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td>
                <mat-radio-group
                  [(ngModel)]="formData.days"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <mat-radio-button
                    class="radio"
                    value="7"
                    style="margin-right: 30px"
                    >In 7 days</mat-radio-button
                  >
                  <mat-radio-button
                    value="30"
                    class="radio"
                    style="margin-right: 30px"
                    >In 30 days</mat-radio-button
                  >
                </mat-radio-group>
              </td>
            </tr>
          </table>
          <div style="margin-left: 10px">
            <button
              (click)="submitDetails()"
              mat-raised-button
              class="btn-get"
              color="primary"
              mat-dialog-close
            >
              Book a demo &nbsp;&nbsp;
              <mat-icon>arrow_right_alt</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="app-footer-3 d-flex">
    <div style="margin-top: 55px">
      <img
        src="../../assets/images/Group 7715.svg"
        alt="Inforida"
        width="100%"
      />
    </div>
    <div class="footer-text">Simplifying school performance</div>
    <div style="display: flex; margin-top: 20px">
      <div class="display foot-nav1">
        <a href="https://www.facebook.com/InforidaTech" class="link"
          ><button mat-button class="foot-text">Facebook</button></a
        >
        <a href="https://twitter.com/InforidaT" class="link"
          ><button mat-button class="foot-text">Twitter</button></a
        >
        <a href="https://www.linkedin.com/company/inforidatech" class="link"
          ><button mat-button class="foot-text">LinkedIn</button></a
        >
        <a href="https://www.instagram.com/inforidaTech/" class="link"
          ><button mat-button class="foot-text">Instagram</button></a
        >
      </div>
      <div style="margin: 0px 45px"></div>
      <div class="display foot-nav2">
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/home"
          [ngClass]="{ 'selected-footer': currentUrlState === '/home' }"
        >
          Home
        </button>
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/about-us"
          [ngClass]="{ 'selected-footer': currentUrlState === '/about-us' }"
        >
          about us
        </button>
        <a mat-button class="mar-50 foot-text" href="https://blog.inforida.com/"
          >blogs</a
        >
        <button
          mat-button
          class="mar-50 foot-text"
          routerLink="/contact-us"
          [ngClass]="{ 'selected-footer': currentUrlState === '/contact-us' }"
        >
          contact us
        </button>
      </div>
    </div>
    <div class="display" style="margin-top: 20px">
      <button mat-button routerLink="/privacy" class="sub-nav">
        Privacy policy
      </button>
      <button mat-button class="sub-nav" routerLink="/terms">
        Terms of use
      </button>
      <button mat-button class="sub-nav" routerLink="/legal">legal</button>
    </div>
    <div style="font-size: 10px">
      © Inforida Technologies 2023 | All Rights Reserved
    </div>
    <div style="font-size: 10px; margin-bottom: 30px">
      Made with ❤️ in India
    </div>
  </div>
</div> -->
